import { BeneficiaryPerformanceType } from "@/types/beneficiaries";

interface OverviewTabType {
  beginningBalance: number;
  employeeContributions: number;
  employerContributions: number;
  giftContributions: number;
  endingBalance: number;
  hasEmployerContributions: boolean;
}

export const useBeneficiaryOverviewData = (
  performanceData: BeneficiaryPerformanceType
): OverviewTabType => {
  if (
    !performanceData ||
    !performanceData.statDetails ||
    performanceData.statDetails.length === 0
  ) {
    return {
      beginningBalance: 0,
      employeeContributions: 0,
      employerContributions: 0,
      giftContributions: 0,
      endingBalance: 0,
      hasEmployerContributions: false,
    };
  }

  const statDetails = performanceData.statDetails;
  const beginningBalance = statDetails[0].openingBalance;
  const endingBalance = statDetails[statDetails.length - 1].closingBalance;

  let totalEmployeeContributions = 0;
  let totalEmployerContributions = 0;
  let hasEmployerContributions = false;

  for (const month of statDetails) {
    for (const transaction of month.statementEntries) {
      const details = transaction.details.toLowerCase();

      if (details.includes("employee contribution")) {
        totalEmployeeContributions += transaction.credit;
      }

      if (details.includes("employer contribution")) {
        totalEmployerContributions += transaction.credit;
        hasEmployerContributions = true;
      }
    }
  }

  return {
    beginningBalance: beginningBalance,
    employeeContributions: totalEmployeeContributions,
    employerContributions: totalEmployerContributions,
    giftContributions: 0,
    endingBalance: endingBalance,
    hasEmployerContributions: hasEmployerContributions,
  };
};
